(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('complain-on-sms', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/complain-on-sms?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_USER','ROLE_EXTERNAL_SYS'],
                pageTitle: 'telestatApp.complainOnSms.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms.html',
                    controller: 'ComplainOnSmsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complainOnSms');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('complain-on-sms-detail', {
            parent: 'complain-on-sms',
            url: '/complain-on-sms/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_USER','ROLE_EXTERNAL_SYS'],
                pageTitle: 'telestatApp.complainOnSms.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-detail.html',
                    controller: 'ComplainOnSmsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complainOnSms');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ComplainOnSms', function($stateParams, ComplainOnSms) {
                    return ComplainOnSms.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'complain-on-sms',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('complain-on-sms-detail.edit', {
            parent: 'complain-on-sms-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complain-on-sms.new', {
            parent: 'complain-on-sms',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                complainTime: null,
                                comment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('complain-on-sms');
                });
            }]
        })
        .state('complain-on-sms.edit', {
            parent: 'complain-on-sms',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-dialog.html',
                    controller: 'ComplainOnSmsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complain-on-sms.delete', {
            parent: 'complain-on-sms',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complain-on-sms/complain-on-sms-delete-dialog.html',
                    controller: 'ComplainOnSmsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ComplainOnSms', function(ComplainOnSms) {
                            return ComplainOnSms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complain-on-sms', null, { reload: 'complain-on-sms' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
